import {
  TransformedSummarizationResult,
  TransformedSummarizationResultInAbs,
} from '../models/transformation';
import {
  SYSTEM_CONSTRAINT_CHAR_LIMIT,
  USER_CLICKED_COPY_ALL,
  USER_CLICKED_UNDO_DELETE_TEXT,
  USER_CLICKED_DELETE_TEXT,
  USER_CHANGED_LENGTH_GAUGE,
  SYSTEM_ERROR_SUMMARIZATION,
  SYSTEM_FINISHED_SUMMARIZATION,
  SYSTEM_STARTED_SUMMARIZATION,
  USER_CHANGED_MODE,
  SYSTEM_SET_KEYWORDS,
  USER_CLICKED_KEYWORD,
  USER_CLEARED_KEYWORDS,
  LOADING_KEYWORDS,
  USER_PASTED_TEXT,
  HYDRATE_STORE_FROM_SESSION,
} from '../models/actions/names';
import {
  SystemConstraintCharLimitAction,
  UserClickedCopyAllAction,
  UserClickedDeleteTextAction,
  UserClickedUndoDeleteTextAction,
  UserChangedLengthGaugeAction,
  SystemErrorSummarizationAction,
  SystemFinishedSummarizationAction,
  SystemStartedSummarizationAction,
  UserChangedModeAction,
  SetKeywords,
  UserClickedKeyword,
  UserClearedKeywords,
  LoadingKeywords,
  UserPastedTextAction,
  HydrateStoreFromSession,
} from '../models/actions';

export const userChangedModeAction = (
  mode: 'abs' | 'ext',
  absLengthGauge: number
): UserChangedModeAction => ({
  type: USER_CHANGED_MODE,
  payload: { summaryMode: mode, absLengthGauge },
});

export const systemStartedSummarizationAction = (
  inputPara: string,
  summaryMode: 'ext' | 'abs',
  isRequillWithChangedConfig: boolean,
  origNumberOfSentences: number,
  triggeredBy?: string
): SystemStartedSummarizationAction => ({
  type: SYSTEM_STARTED_SUMMARIZATION,
  payload: {
    inputPara,
    summaryMode,
    isRequillWithChangedConfig,
    origNumberOfSentences,
    triggeredBy,
  },
});

export const systemFinishedSummarizationAction = (
  summarized: TransformedSummarizationResult | TransformedSummarizationResultInAbs
): SystemFinishedSummarizationAction => ({
  type: SYSTEM_FINISHED_SUMMARIZATION,
  payload: summarized,
});

export const systemErrorSummarizationAction = (err: unknown): SystemErrorSummarizationAction => ({
  type: SYSTEM_ERROR_SUMMARIZATION,
  payload: { err },
});

export const userChangedLengthGaugeAction = (
  newValue: number,
  summaryMode: 'ext' | 'abs',
  summarySentenceSequence: string[],
  absCurrentValue: number
): UserChangedLengthGaugeAction => ({
  type: USER_CHANGED_LENGTH_GAUGE,
  payload: {
    newValue,
    summaryMode,
    summarySentenceSequence,
    absCurrentValue,
  },
});

export const userClickedDeleteTextAction = (): UserClickedDeleteTextAction => ({
  type: USER_CLICKED_DELETE_TEXT,
  payload: {},
});

export const userClickUndoDeleteTextAction = (): UserClickedUndoDeleteTextAction => ({
  type: USER_CLICKED_UNDO_DELETE_TEXT,
  payload: {},
});

export const userClickedCopyAllAction = (
  copiedText: string,
  triggeredBy: string
): UserClickedCopyAllAction => ({
  type: USER_CLICKED_COPY_ALL,
  payload: { copiedText, triggeredBy },
});

export const characterLimitExceededAction = (
  charLimit: number
): SystemConstraintCharLimitAction => ({
  type: SYSTEM_CONSTRAINT_CHAR_LIMIT,
  payload: {
    charLimit,
  },
});

export const setKeywords = (keywords: Array<string>): SetKeywords => ({
  type: SYSTEM_SET_KEYWORDS,
  payload: keywords,
});

export const userClickedKeyword = (keyword: string): UserClickedKeyword => ({
  type: USER_CLICKED_KEYWORD,
  payload: keyword,
});
export const userClearedKeywords = (): UserClearedKeywords => ({
  type: USER_CLEARED_KEYWORDS,
});
export const loadingKeywords = (loading: boolean): LoadingKeywords => ({
  type: LOADING_KEYWORDS,
  loading,
});

export const userPastedText = (
  triggeredBy: string,
  textLength?: number | undefined
): UserPastedTextAction => ({
  type: USER_PASTED_TEXT,
  payload: { triggeredBy, textLength },
});

export const hydrateStoreFromSession = (src: string, store: any): HydrateStoreFromSession => ({
  type: HYDRATE_STORE_FROM_SESSION,
  payload: { src, store },
});
